import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from '../../../guards/auth/auth.guard';
import { RouterModule } from '@angular/router';
import { RoleGuard } from '@guards/role/role.guard';
import { BlackboxesComponent } from './blackboxes.component';
import { SetupBlackboxDialogComponent } from '@components/dialog/setup-blackbox-dialog/setup-blackbox-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'blackboxes',
          component: BlackboxesComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
              path: 'setup',
              component: SetupBlackboxDialogComponent,
              data: {roles: ['Operator']},
            },
            {
              path: 'setup/:key',
              component: SetupBlackboxDialogComponent,
              data: {roles: ['Operator']},
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class BlackboxesModule { }
